module.exports = __webpack_public_path__ + "img/Maneki Street_Metapass.b09c0965.png";